import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, FormControl } from '@material-ui/core';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import { BASE_URL_TRUSTNET } from './api';

function Authorize(props) {
  const classes = useStyles(props);
  const [loader, setLoader] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(async () => {
    setLoader(true);
    var url = new URL(window.location.href);
    const queryParams = new URLSearchParams(window.location.search);
    const client_id = queryParams.get('client_id');
    const redirect_uri = queryParams.get('redirect_uri');
    const response_type = queryParams.get('response_type');
    const nonce = queryParams.get('nonce');
    const state = queryParams.get('state');
    const scope = queryParams.get('scope');
    const response_mode = queryParams.get('response_mode');
    const prompt = queryParams.get('prompt');
    const ui_locales = queryParams.get('ui_locales');

    const params = {
      scope,
      state,
      redirect_uri,
      type: 'email',
      client_id,
      response_type,
      nonce,
    };

    const res = await Axios['get'](`${BASE_URL_TRUSTNET}/authorize`, {
      params,
    });

    if (res.data.success) {
      setLoader(false);
      window.location.href = res.data.Location;
    } else {
      setLoader(false);
      enqueueSnackbar(res.data.message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        persist: false,
      });
    }

    return () => {};
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress
        size={50}
        style={{
          color: '#283593',
        }}
      />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '100%',
    paddingTop: 20,
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default Authorize;
